import moment from "moment";

export const getRemainingTokenExpirationTime = (tokenExipreAt: string) => {
  return moment(tokenExipreAt).diff(moment());
};

export const getTokenRefreshConfirmationRemainingTime = (
  tokenExpireAt: string,
  confirmationTimeBeforeExpireInMinute: number
) => {
  return getTokenRefreshConfirmationDisplayTime(
    tokenExpireAt,
    confirmationTimeBeforeExpireInMinute
  ).diff(moment());
};

export const checkIfTokenRefreshConfirmationShouldBeDisplayed = (
  tokenExpireAt: string,
  confirmationTimeBeforeExpireInMinute: number
) => {
  var isTimePassed = getTokenRefreshConfirmationDisplayTime(
    tokenExpireAt,
    confirmationTimeBeforeExpireInMinute
  ).isBefore(moment());
  return isTimePassed;
};

const getTokenRefreshConfirmationDisplayTime = (
  tokenExpireAt: string,
  confirmationTimeBeforeExpireInMinute: number
) => {
  var confirmationDisplayTime = moment(tokenExpireAt).subtract(
    confirmationTimeBeforeExpireInMinute,
    "minutes"
  );
  return confirmationDisplayTime;
};
